
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { showModal, showNestedModal } from "../../features/modal/modalSlice"
import { useScrollLock } from "../../hooks/useScrollLock"
import styled from "styled-components"
import PageTopTitle from "../shared/PageTopTitle"
import Button from "../shared/button/Btn"
import SmallSpinner from "../shared/spinners/SmallSpinner"


const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 1000px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            padding: 40px 0;
            width: 800px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;
            p{
                font-weight: var(--font-weight-md);
                font-size: var(--font-size-md);
                text-transform: capitalize;

                span{
                    font-weight: var(--font-weight-xl);
                }
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin: 30px 0;
        }
    }
`

const AracCezaSorguModal = () => {

    const dispatch = useDispatch()

    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const {aracCezaSorgu, isLoadingGetAracCezaSorgu} = useSelector(state => state.uyelerAraclar)

        //! bu modal açıldığnda ekran ı lock lamak için
        useEffect(() => {
                lockScroll()
            return () => {
                    unlockScroll()
            }
            }, [lockScroll, unlockScroll, aracCezaSorgu])
        
            //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
            useEffect(() => {
                if (location.pathname !== modalLocation) {
                    dispatch(showModal(null))
                }
            }, [dispatch, location.pathname, modalLocation])


    

  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Araç Ceza Belgesi"}/>
        <div className="content">
        {isLoadingGetAracCezaSorgu && <SmallSpinner size={"40px"} color={"#fff"} bgColor={"#BB2649"}/>
        }
            {
                aracCezaSorgu &&
                <p><span>{aracCezaSorgu?.plaka}</span> plakalı araca kayıtlı <span>{aracCezaSorgu?.message}</span></p>
            }
        </div>
        <div className='button-grp'>
            <Button color={"#E85546"} background={"#0EAC00"} width="220px" radius={"10px"} padding="0 10px" handleClick={()=> dispatch(showModal(null))}>Geri Dön</Button>
        </div>
    </div>
</ModalContainer>
  )
}

export default AracCezaSorguModal